import classNames from 'classnames';
import React from 'react';

//
// Checklist
//

interface ChecklistProps {
  as?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

const Checklist = React.forwardRef<HTMLElement, ChecklistProps>(({ as: Tag = 'div', className, ...props }, ref) => {
  const classes = classNames('checklist', className);

  return <Tag className={classes} ref={ref} {...props} />;
}) as any;

Checklist.displayName = 'Checklist';

//
// Checklist item
//

Checklist.Item = React.forwardRef<HTMLElement, ChecklistProps>(({ as: Tag = 'div', className, ...props }, ref) => {
  const classes = classNames('checklist-item', className);

  return <Tag className={classes} ref={ref} {...props} />;
});

Checklist.Item.displayName = 'Checklist.Item';

export default Checklist;
